import { writable } from 'svelte/store';
import * as util from "../js/util.js";

function createMyStore() {
    const { subscribe, set, update, get } = writable({
        langs: new Array()
    });

    return {
        subscribe,
        getLangs: async () => {
            const json = await util.fetchJson('api/Lang/getlangsforadmin');
            update(n => { return Object.assign(n, { langs: json }) });
            return json;

        },
        saveLang: async (lang) => {
            var ret = await util.fetchJsonWithMethod('PUT', 'api/Lang/savelang', lang);
            return ret;
        },
        reset: () => set(new Array())
    };
}
export const languagesStore = createMyStore();

